<nav aria-label="Trilha de navegação">
  <ol class="trilha-navegacao">
    @for (passo of passos(); track $index; let ultimo = $last) {
      <li
        class="trilha-navegacao__passo"
        [class.trilha-navegacao__passo--atual]="ultimo"
        [attr.aria-current]="ultimo ? 'page' : null"
      >
        {{ passo }}
      </li>
    }
  </ol>
</nav>
